/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CustomerInvoice,
} from '../models';
import {
    CustomerInvoiceFromJSON,
    CustomerInvoiceToJSON,
} from '../models';

export interface GetInvoiceFileRequest {
    customerId: string;
    invoiceId: string;
    download: boolean;
    xPcsImpersonatedUser?: string;
}

export interface GetInvoicesRequest {
    customerId: string;
    xPcsImpersonatedUser?: string;
}

/**
 * 
 */
export class InvoicesApi extends runtime.BaseAPI {

    /**
     * Get File associated to an invoice
     * Get Invoice file
     */
    async getInvoiceFileRaw(requestParameters: GetInvoiceFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getInvoiceFile.');
        }

        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId','Required parameter requestParameters.invoiceId was null or undefined when calling getInvoiceFile.');
        }

        if (requestParameters.download === null || requestParameters.download === undefined) {
            throw new runtime.RequiredError('download','Required parameter requestParameters.download was null or undefined when calling getInvoiceFile.');
        }

        const queryParameters: any = {};

        if (requestParameters.download !== undefined) {
            queryParameters['download'] = requestParameters.download;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPcsImpersonatedUser !== undefined && requestParameters.xPcsImpersonatedUser !== null) {
            headerParameters['x-pcs-impersonated-user'] = String(requestParameters.xPcsImpersonatedUser);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-ms-client-principal"] = this.configuration.apiKey("x-ms-client-principal"); // api-security authentication
        }

        const response = await this.request({
            path: `/invoice/{customerId}/{invoiceId}/file`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))).replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get File associated to an invoice
     * Get Invoice file
     */
    async getInvoiceFile(requestParameters: GetInvoiceFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getInvoiceFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a list of invoices
     * Get Invoices
     */
    async getInvoicesRaw(requestParameters: GetInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CustomerInvoice>>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getInvoices.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPcsImpersonatedUser !== undefined && requestParameters.xPcsImpersonatedUser !== null) {
            headerParameters['x-pcs-impersonated-user'] = String(requestParameters.xPcsImpersonatedUser);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-ms-client-principal"] = this.configuration.apiKey("x-ms-client-principal"); // api-security authentication
        }

        const response = await this.request({
            path: `/invoice/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerInvoiceFromJSON));
    }

    /**
     * Gets a list of invoices
     * Get Invoices
     */
    async getInvoices(requestParameters: GetInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CustomerInvoice>> {
        const response = await this.getInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
